import Logger from '../../../lib/analytics/logger';
import { MISSIONS_EVENT_TYPES } from '../constants/events';
import { EVENT_ACTIONS, EVENT_DOMAINS, EVENT_SCREENS, EVENT_WIDGETS } from '../../../lib/analytics/constants';
export var sendMissionsEvent = function sendMissionsEvent(eventType, payload) {
  switch (eventType) {
    case MISSIONS_EVENT_TYPES.ENTER_MISSIONS_SCREEN:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.ENTER_MISSIONS_SCREEN, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].MAIN,
        widget: null
      });
      break;

    case MISSIONS_EVENT_TYPES.START_MISSIONS_TUTORIAL:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.START_MISSIONS_TUTORIAL, {
        action: EVENT_ACTIONS.START,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].TUTORIAL,
        widget: null,
        context_tutorial_step: payload.step
      });
      break;

    case MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_NEXT_STEP:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_NEXT_STEP, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].TUTORIAL,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.MISSIONS].TUTORIAL_NEXT_STEP,
        context_tutorial_step: payload.step
      });
      break;

    case MISSIONS_EVENT_TYPES.DISPLAY_MISSIONS_TUTORIAL_STEP:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.DISPLAY_MISSIONS_TUTORIAL_STEP, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].TUTORIAL,
        widget: null,
        context_tutorial_step: payload.step
      });
      break;

    case MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_SKIP:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_SKIP, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].TUTORIAL,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.MISSIONS].TUTORIAL_SKIP,
        context_tutorial_step: payload.step
      });
      break;

    case MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_COMPLETE:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.MISSIONS_TUTORIAL_COMPLETE, {
        action: EVENT_ACTIONS.COMPLETE,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].TUTORIAL,
        widget: null,
        context_tutorial_step: payload.step
      });
      break;

    case MISSIONS_EVENT_TYPES.DISPLAY_MISSIONS_WIDGET:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.DISPLAY_MISSIONS_WIDGET, {
        action: EVENT_ACTIONS.DISPLAY,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.GENERAL].LOBBY,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.GENERAL].MISSIONS_WIDGET
      });
      break;

    case MISSIONS_EVENT_TYPES.MISSIONS_CARD_REWARD_CLAIM:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.MISSIONS_CARD_REWARD_CLAIM, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.MISSIONS,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.MISSIONS].MISSION_CARD_REWARD_CLAIM_BUTTON
      });
      break;

    case MISSIONS_EVENT_TYPES.MISSIONS_OPEN_INFO_SCREEN:
      Logger.sendEvent(MISSIONS_EVENT_TYPES.MISSIONS_OPEN_INFO_SCREEN, {
        action: EVENT_ACTIONS.PRESS,
        domain: EVENT_DOMAINS.MISSIONS,
        screen: EVENT_SCREENS[EVENT_DOMAINS.MISSIONS].MAIN,
        widget: EVENT_WIDGETS[EVENT_DOMAINS.MISSIONS].MISSIONS_INFO_BUTTON
      });
      break;

    default:
      break;
  }
};